import Bidding from "./Bidding";

export default Bidding;
